
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 6.73L5.228 3.992l2.734-2.76L6.729 0 3.992 2.773 1.222.038 0 1.26l2.774 2.747L.038 6.778 1.26 8l2.746-2.773 2.762 2.735L8 6.729z","fill":"#fff"}})])
          )
        }
      }
    